import React from "react";
import { Modal, Tree, Spin, Typography, message, Empty } from "antd";
import {
 DownOutlined,
} from "@ant-design/icons";
import Context from "../../../Context";

const { Text } = Typography;

function compareSortList(a, b) {
  const sa = Array.isArray(a.sortlist) ? a.sortlist : [];
  const sb = Array.isArray(b.sortlist) ? b.sortlist : [];
  const len = Math.max(sa.length, sb.length);
  for (let i = 0; i < len; i++) {
    const va = sa[i] ?? 0;
    const vb = sb[i] ?? 0;
    if (va !== vb) return va - vb;
  }
  // fallback
  if (a.sequence !== b.sequence) return (a.sequence || 0) - (b.sequence || 0);
  return (a.name || "").localeCompare(b.name || "");
}

function buildTree(itemsRaw = []) {
  // Исключаем корни из дерева, но их детей показываем как верхний уровень
  const roots = new Set(itemsRaw.filter(i => i.typecode === "root").map(i => i.id));
  const items = itemsRaw.filter(i => (i.typecode !== "root" && i.typecode !== "guest"));

  const map = new Map();
  const nodes = new Map();

  items.forEach((it) => map.set(it.id, it));

  items.forEach((it) => {
    nodes.set(it.id, {
      key: it.id,
      selectable: true,
      isLeaf: false,
      originalItem: it,
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div>{it.name}</div>
            {it.description ? (
              <div style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>{it.description}</div>
            ) : null}
          </div>
        </div>
      ),
      children: [],
    });
  });

  const topLevel = [];
  items.forEach((it) => {
    const node = nodes.get(it.id);
    if (!it.parent || roots.has(it.parent) || !nodes.has(it.parent)) {
      topLevel.push(node);
    } else {
      nodes.get(it.parent).children.push(node);
    }
  });

  // Рекурсивная сортировка
  const sortRec = (list) => {
    list.sort((a, b) => compareSortList(a.originalItem, b.originalItem));
    list.forEach((n) => sortRec(n.children));
  };
  sortRec(topLevel);

  // Помечаем листья
  const markLeaf = (list) => {
    list.forEach((n) => {
      n.isLeaf = !n.children || n.children.length === 0;
      if (n.children && n.children.length) markLeaf(n.children);
    });
  };
  markLeaf(topLevel);

  return topLevel;
}

export default class HeaderArea extends React.Component {
  static contextType = Context;

  state = {
    loading: false,
    changing: false,
    items: [],
    activeItem: {},
    visible: false,
    treeData: [],
    selectedKeys: [],
  };

  componentDidMount() {
    this.load();
  }

  openModal = () => this.setState({ visible: true });
  closeModal = () => {
    if (!this.state.changing) this.setState({ visible: false });
  };

  // Единая рассылка события + вызов пропса onChange
  broadcastChange = (area) => {
    if (typeof this.props.onChange === "function") {
      this.props.onChange(area);
    }
  };

  load = async () => {
    try {
      this.setState({ loading: true });

      const itemsArr = await this.context.api.q("/member/area", {}, { toArray: true });
      const activeItem = await this.context.api.q("/current/area");
      const treeData = buildTree(itemsArr, activeItem?.id);

      this.setState({
        loading: false,
        items: itemsArr,
        activeItem: activeItem || {},
        treeData,
        selectedKeys: activeItem?.id ? [activeItem.id] : [],
      });
    } catch (e) {
      this.setState({ loading: false });
      message.error("Не удалось загрузить список подразделений");
    }
  };

  onSelect = async (selectedKeys, info) => {
    const node = info?.node;
    const item = node?.originalItem;
    if (!item || !item.id) return;

    // Ничего не делаем, если выбрали уже активный
    if (this.state.activeItem?.id === item.id) {
      this.setState({ selectedKeys });
      this.closeModal();
      return;
    }

    try {
      this.setState({ changing: true, selectedKeys });
      const result = await this.context.api.q("/session/set/area", {id: item.id});
      if (result) {
        this.broadcastChange(item.id);
        this.setState({
          changing: false,
          visible: false,
        });
        this.load();
      } else {
        this.setState({ changing: false });
        message.error("Не удалось изменить подразделение");
      }
    } catch (e) {
      this.setState({ changing: false });
      message.error("Ошибка при смене подразделения");
    }
  };

  renderCurrent() {
    const { activeItem } = this.state;

    return (
      <div
        className="gx-d-flex gx-align-items-center"
        title="Текущее подразделение"
        style={{ cursor: "pointer" }}
        onClick={this.openModal}
      >
        <span className="gx-text-primary gx-text-ellipsis" style={{ maxWidth: 220 }}>
          {activeItem?.name || "Выбрать подразделение"}
        </span>
      </div>
    );
  }

  renderModal() {
    const { visible, loading, changing, treeData, selectedKeys } = this.state;

    return (
      <Modal
        title="Выберите подразделение"
        open={visible}
        onCancel={this.closeModal}
        footer={null}
        width={560}
        maskClosable={!changing}
        destroyOnClose
      >
        <Spin spinning={loading || changing}>
          {treeData && treeData.length ? (
            <Tree className={"gx-area-name"}
              switcherIcon={<DownOutlined />}
              treeData={treeData}
              selectedKeys={selectedKeys}
              defaultExpandedKeys={selectedKeys}
              defaultExpandAll
              onSelect={this.onSelect}
            />
          ) : (
            <Empty
              description={<Text type="secondary">Список подразделений пуст</Text>}
            />
          )}
        </Spin>
      </Modal>
    );
  }

  render() {
    return (
      <>
        {this.renderCurrent()}
        {this.renderModal()}
      </>
    );
  }
}
